import api from "./api";
import UserService from "./user.service";

// status: 0 pending, 1 approved w/PTO, 2 approved w/o PTO, 3 rejected, 10 cancelled
export const TIME_OFF_STATUS = {
  PENDING: 0,
  APPROVED_PTO: 1,
  APPROVED_NO_PTO: 2,
  REJECTED: 3,
  CANCELLED: 10,
};

const getAll = (params) => {
  return api.get("/api/time-off", { params });
};

// payload: { type, startDate, endDate, notes?, userId }
const create = (payload) => {
  return api.post("/api/time-off/create", payload);
};

const getOne = (id) => {
  return api.get(`/api/time-off/${id}`);
};

const getConflictingWos = (id) => {
  return api.get(`/api/time-off/${id}/conflicting-wos`);
};

// Generic patch for editing a request's fields (type/dates/notes/status).
const update = (id, payload) => {
  return api.patch(`/api/time-off/${id}`, payload);
};

// status: 0 pending, 1 approved with PTO, 2 approved without PTO, 3 rejected.
// Records the deciding admin (decidedById) so the requester can see who decided.
const updateStatus = (id, status, rejectionReason) => {
  const payload = { status };
  if (rejectionReason) payload.rejectionReason = rejectionReason;
  const me = UserService.getCurrentUser();
  if (me?.id) payload.decidedById = me.id;
  return api.patch(`/api/time-off/${id}`, payload);
};

// Requester cancels their own (pending) request.
const cancel = (id) => {
  return api.patch(`/api/time-off/${id}`, { status: TIME_OFF_STATUS.CANCELLED });
};

const TimeOffService = {
  getAll,
  create,
  getOne,
  getConflictingWos,
  update,
  updateStatus,
  cancel,
};

export default TimeOffService;
